import { BarcodeSvg } from "@/components/tags/BarcodeSvg";
import { paginate, perPage, slotPos } from "@/lib/tagLayouts";

const expShort = (iso) => (iso ? `${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "");

export function Tag({ t, L, fields, bizName, idx }) {
  const meta = [fields.batch && t.batch && `B: ${t.batch.batch_no}`, fields.expiry && t.batch && `EXP ${expShort(t.batch.expiry)}`].filter(Boolean).join(" · ");
  return (
    <div className="tag" style={{ width: `${L.w}mm`, height: `${L.h}mm`, padding: `${L.pad}mm` }} data-testid={`tag-${idx}`}>
      {fields.business_name && <div className="tag-biz" style={{ fontSize: `${L.meta}pt` }} data-testid={`tag-business-${idx}`}>{bizName}</div>}
      <div className="tag-name" style={{ fontSize: `${L.name}pt` }} data-testid={`tag-name-${idx}`}>{t.name}</div>
      <div className="tag-bc-slot" style={{ maxWidth: `${L.bcMax}mm`, minHeight: `${L.bcMinH}mm` }}>
        {t.barcode ? (
          <BarcodeSvg code={t.barcode} digitsPt={L.digits} testId={`tag-barcode-${idx}`} />
        ) : (
          <div className="tag-bc-pending" style={{ fontSize: `${L.meta}pt` }} data-testid={`tag-barcode-pending-${idx}`}>in-store barcode (20…) created on print</div>
        )}
      </div>
      {(fields.price || meta) && (
        <div className="tag-foot">
          {fields.price && <span className="tag-price" style={{ fontSize: `${L.price}pt` }} data-testid={`tag-price-${idx}`}>{t.priceText}</span>}
          {meta && <span className="tag-meta" style={{ fontSize: `${L.meta}pt` }} data-testid={`tag-meta-${idx}`}>{meta}</span>}
        </div>
      )}
    </div>
  );
}

// One printable page: an A4 sheet of slots, or a single thermal label. `first` = global index of the first tag.
export function TagPage({ L, slots, pi, first, fields, bizName, outline }) {
  let n = first;
  if (L.kind !== "a4")
    return (
      <div className={`tag-page tag-thermal ${outline ? "tag-outline" : ""}`} style={{ width: `${L.w}mm`, height: `${L.h}mm` }} data-testid={`tag-label-page-${pi}`}>
        <Tag t={slots[0]} L={L} fields={fields} bizName={bizName} idx={n} />
      </div>
    );
  return (
    <div className={`tag-page tag-a4 ${outline ? "tag-outline" : ""}`} data-testid={`tag-sheet-${pi}`}>
      {slots.map((t, si) => (
        <div key={si} className="tag-slot" style={slotPos(L, si)}>
          {t ? <Tag t={t} L={L} fields={fields} bizName={bizName} idx={n++} /> : <div className="tag-blank" style={{ width: `${L.w}mm`, height: `${L.h}mm` }} data-testid={`tag-blank-${si}`} />}
        </div>
      ))}
    </div>
  );
}

export function pagesWithIndex(L, tags, start) {
  const blanks = L.kind === "a4" ? Math.max(0, start - 1) : 0;
  return paginate(L, tags, start).map((slots, pi) => ({ slots, pi, first: Math.max(0, pi * perPage(L) - blanks) }));
}

export function TagPages({ L, tags, start, fields, bizName }) {
  return pagesWithIndex(L, tags, start).map((p) => <TagPage key={p.pi} L={L} {...p} fields={fields} bizName={bizName} />);
}
